import { getMyNotificationDetail } from "@/services";
import { NOTIFICATION_QUERY_KEYS } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

interface Attachment {
  id: number;
  name: string;
  url: string;
  type: string;
}

function useGetMyNotificationDetail(notificationId: number) {
  const { data, ...detail } = useQuery({
    queryKey: [NOTIFICATION_QUERY_KEYS.MY_DETAIL, notificationId],
    queryFn: () => getMyNotificationDetail(notificationId),
    retry: 1,
    enabled: !!notificationId,
  });

  const notification = data?.data;

  // Lọc attachments có type là images, videos, documents
  const [images, videos, documents] = useMemo(() => {
    const images: string[] = [];
    const videos: Attachment[] = [];
    const documents: Attachment[] = [];

    notification?.notification?.attachments?.forEach((attachment) => {
      if (attachment.type.startsWith("image/")) {
        images.push(attachment.url);
      } else if (attachment.type.startsWith("video/")) {
        videos.push(attachment);
      } else {
        documents.push(attachment);
      }
    });

    return [images, videos, documents];
  }, [notification]);

  return {
    notification,
    images,
    videos,
    documents,
    ...detail,
  };
}

export { useGetMyNotificationDetail };
